var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaselineCreateBlack18Dp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.357,
    height: 23.357,
    viewBox: "0 0 23.357 23.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M927.42,2274.673v4.867h4.867l14.36-14.36-4.867-4.867Zm22.978-13.244a1.3,1.3,0,0,0,0-1.836l-3.03-3.03a1.3,1.3,0,0,0-1.836,0l-2.375,2.375,4.867,4.867Z",
    transform: "translate(-927.42 -2256.182)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaselineCreateBlack18Dp);
export default __webpack_public_path__ + "static/media/baseline_create_black_18dp.0a5169e1215fd410cfdf028f00191f79.svg";
export { ForwardRef as ReactComponent };